



























import Vue from 'vue';
import {Component} from 'vue-property-decorator';
//@ts-ignore
import store from "../../store";

@Component({
    components: {},
    props: {
        message: {
            type: Object,
            required: true
        }
    }
})

export default class ChatCommandMessage extends Vue {
    private message!: any;

    /**
     * Массив игроков
     * @private
     */
    private get playerName(): string
    {
        const state = store.getters.getGameState;
        return state.playersData[this.message.playerId].name.toString();
    }

    private get playerColor(): string
    {
        const state = store.getters.getGameState;

        if (typeof state.playersData[this.message.playerId] === 'undefined'|| !state.playersData[this.message.playerId].preferred_color_code) {
            return '';
        }
        return state.playersData[this.message.playerId].preferred_color_code.toString();
    }
}
